<template>
  <BField
    :label="label"
    :label-for="id"
    :message="message"
    :type="{ 'is-danger': !valid }"
    :custom-class="customClass"
  >
    <BInput
      :id="id"
      :name="name"
      type="password"
      icon="lock"
      minlength="8"
      maxlength="50"
      placeholder="Contraseña123"
      :value="value"
      :loading="loading"
      :required="required"
      :disabled="disabled"
      :pattern="pattern"
      :has-counter="false"
      password-reveal
      @focus="onFocus"
      @input="onChange"
      @change="onChange"
      @blur="onBlur"
    />
  </BField>
</template>

<script>
import set from 'lodash/set';

export default {
  name: 'AppInputPassword',
  props: {
    id: { type: [String, Number], default: 'password' },
    name: { type: [String, Number], default: 'password' },
    label: { type: String, default: 'Contraseña' },
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    pattern: { type: String, default: '(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,50}' },
    errorMessage: {
      type: [String, Array],
      default: () => [
        'La contraseña debe tener:',
        'Mayuscula, Minuscula, Número/Caracter Especial y mínimo 8 dígitos',
      ],
    },
  },
  data() { return { valid: true }; },
  computed: {
    customClass() { return !this.valid ? 'has-text-danger' : ''; },
    message() { return !this.valid ? this.errorMessage : ''; },
  },
  methods: {
    toLowerCase(event) {
      const newEvent = {};

      set(newEvent, 'target.name', this.name);
      set(newEvent, 'target.value', event);

      return newEvent;
    },
    onFocus(event) {
      this.valid = true;
      this.$emit('focus', event);
    },
    onInput(event) { this.$emit('input', this.toLowerCase(event)); },
    onChange(event) { this.$emit('change', this.toLowerCase(event)); },
    onBlur(event) {
      this.valid = event.target.value.length > 0 ? event.target.checkValidity() : true;
      this.$emit('blur', event);
    },
  },
};
</script>
